export default {
  apiContactFormPostinId: 'f7905429-4a93-4adf-9e88-fed6a2c66091',
  searchPlaceholder: 'Buscar en los productos...',
  searchPlaceholderProducts: 'Buscar producto...',
  yourData: 'Tus datos:',
  name: 'Nombre*',
  surname: 'Apellido*',
  email: 'Correo electrónico*',
  phone: 'Teléfono*',
  city: 'Ciudad*',
  role: 'Tarea',
  requestType: 'Tipo de solicitud',
  company: 'Empresa',
  message: 'Mensaje',
  termsExtLabel:
    'Consiento el tratamiento de mis datos personales según la información proporcionada y recibir información por correo electrónico o teléfono a través de este formulario.',
  newsletterExtLabel:
    'Deseo suscribirme al boletín para mantenerme actualizado sobre las novedades de Bioenología (puedes darte de baja en cualquier momento a través del enlace presente en cada boletín que recibas)',
  termsError: 'Aceptar los términos y condiciones',
  sendRequest: 'Enviar solicitud',
  requests: 'Comercial,Apoyo,Otro',
  roles: 'Propietario,Enólogo,Jefe de producción',
  success: 'Solicitud enviada con éxito',
  error: 'Se ha producido un error',
  endMessage:
    'Bioenología utilizará los datos personales únicamente para proporcionar los servicios solicitados y no los cederá a terceros con fines publicitarios. Podrás solicitar la eliminación de tus datos de nuestros sistemas en cualquier momento a través de este formulario.',

  // Product contact
  productContact: 'Solicitar información<br> sobre el producto',
  forProduct: 'Producto seleccionado:',
  forProducts: 'Productos seleccionados:',
  otherProducts: '¿Quieres añadir otros productos a tu solicitud?',
  otherProductsText:
    'Selecciona de la lista o búscalos a través del campo de búsqueda a continuación.',
}
